import {
  initialState,
  Actions,
  State,
  GET_ALL_CONTENTS,
  GET_ALL_CONTENTS_SUCCESS,
  GET_ALL_CONTENTS_ERROR,
  RESET_GET_ALL_CONTENTS,
  UPDATE_CONTENTS,
} from '../../types/content/get-all'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_CONTENTS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ALL_CONTENTS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ALL_CONTENTS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case UPDATE_CONTENTS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: false,
        },
      }
    case RESET_GET_ALL_CONTENTS:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
